module.exports = __webpack_public_path__ + "media/images/icons/calendar-noti-icon-d5b2876c7c7e6bda6a0992e4795b1226.svg";